import { render, staticRenderFns } from "./vLocaleChanger.vue?vue&type=template&id=3b24f61c&scoped=true&"
import script from "./vLocaleChanger.vue?vue&type=script&lang=js&"
export * from "./vLocaleChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24f61c",
  null
  
)

export default component.exports